<template lang="pug">
  .v-circle(:style="styles")
</template>

<script>
export default {
  name: 'VCircle',

  props: {
    color: {
      type: String,
      default: '#ccc'
    },
    size: {
      type: [String, Number],
      default: 1.7
    }
  },

  computed: {
    styles () {
      return {
        '--color': this.color,
        '--size': `${this.size}rem`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-circle {
  height: var(--size);
  width: var(--size);
  border-radius: 50%;
  background-color: var(--color);
}
</style>
